import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "album py-5 bg-light" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_6 = {
  key: 2,
  class: "container"
}
const _hoisted_7 = { class: "row justify-content-md-center" }
const _hoisted_8 = { class: "col-lg-3" }
const _hoisted_9 = {
  class: "card sticky-top",
  style: {"top":"70px","z-index":"0"}
}
const _hoisted_10 = { class: "row justify-content-md-center" }
const _hoisted_11 = { class: "col-6 col-lg-12" }
const _hoisted_12 = { class: "card-body col-6 col-lg-12" }
const _hoisted_13 = {
  class: "card-title",
  style: {"font-weight":"bold"}
}
const _hoisted_14 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_15 = {
  key: 0,
  class: "card-subtitle mb-2 text-muted"
}
const _hoisted_16 = {
  key: 1,
  class: "card-subtitle mb-2 text-muted"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Leggi")
const _hoisted_18 = { class: "col-lg-9" }
const _hoisted_19 = { class: "table table-striped table-hover" }
const _hoisted_20 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Titolo"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Data")
  ])
], -1)
const _hoisted_21 = { style: {"padding":"0px"} }
const _hoisted_22 = { style: {"padding":"0px"} }
const _hoisted_23 = { style: {"padding":"0px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_NavBar),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock("h1", _hoisted_1, _toDisplayString(_ctx.data.title), 1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4
          ]))
        : (_ctx.error)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("h5", null, _toDisplayString(_ctx.error), 1)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("img", {
                          src: _ctx.data.cover,
                          class: "card-img-top",
                          alt: "..."
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_12, [
                        _createVNode("h4", _hoisted_13, _toDisplayString(_ctx.data.title), 1),
                        _createVNode("h6", _hoisted_14, "Stato originale: " + _toDisplayString(_ctx.$parseStatus(_ctx.data.status)), 1),
                        (_ctx.data.author)
                          ? (_openBlock(), _createBlock("h6", _hoisted_15, "Autore: " + _toDisplayString(_ctx.data.author), 1))
                          : _createCommentVNode("", true),
                        (_ctx.data.artist)
                          ? (_openBlock(), _createBlock("h6", _hoisted_16, "Artista: " + _toDisplayString(_ctx.data.artist), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_router_link, {
                          to: '/chapter/'+this.$route.params.id+'/'+_ctx.data.chapters[0].chapter,
                          class: "btn btn-primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("table", _hoisted_19, [
                    _hoisted_20,
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.chapters.slice().reverse(), (ch) => {
                        return (_openBlock(), _createBlock("tr", { key: ch }, [
                          _createVNode("th", _hoisted_21, [
                            _createVNode(_component_router_link, {
                              to: '/chapter/'+this.$route.params.id+'/'+ch.chapter,
                              style: {"text-decoration":"none","color":"rgb(33, 37, 41)","display":"block","padding":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString((ch.volume ? 'Vol.'+ch.volume+' ' : '') + 'Ch.'+ch.chapter), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createVNode("th", _hoisted_22, [
                            _createVNode(_component_router_link, {
                              to: '/chapter/'+this.$route.params.id+'/'+ch.chapter,
                              style: {"text-decoration":"none","color":"rgb(33, 37, 41)","display":"block","padding":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(ch.title||' '), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createVNode("td", _hoisted_23, [
                            _createVNode(_component_router_link, {
                              to: '/chapter/'+this.$route.params.id+'/'+ch.chapter,
                              style: {"text-decoration":"none","color":"rgb(33, 37, 41)","display":"block","padding":"8px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$timeSince(parseInt(ch.time))) + " fa", 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
    ])
  ]))
}